import { Form, Select, Space } from 'antd'
import _ from 'lodash'
import { FC } from 'react'
import Roller from '../../../../../types/api/roller'
import { requiredOneElementRules } from '../../../../../constants/forms/validation/rules'
import { formatRollerDisplay } from '../../../../../helpers/format-roller-display'

interface RollersProps {
    variants: {
        distance: number
        numberOfLabels: number
        roller: Roller
    }[]
}

const Rollers: FC<RollersProps> = ({ variants }) => {
    return (
        <Form.Item
            name={'roller'}
            label={'Кол-во этикеток в ручье'}
            rules={requiredOneElementRules}
        >
            <Select
                style={{ width: 420 }}
                options={variants.map(item => {
                    return {
                        key: item.roller.id + item.numberOfLabels + item.distance,
                        // value: item.roller.id + item.numberOfLabels + item.distance,
                        value: JSON.stringify({
                            roller: item.roller.documentId,
                            numberOfLabels: item.numberOfLabels,
                            distance: item.distance,
                        }),
                        label: (
                            <Space>
                                <div style={{ width: 90 }}>Межэт: {item.distance.toFixed(3)}</div>
                                <div style={{ width: 70 }}>В ручье: {item.numberOfLabels}</div>
                                <div style={{ width: 90 }}>Вал: {formatRollerDisplay(item.roller.roller)}</div>
                                <div style={{ width: 120 }}>
                                    {_.uniq(
                                        item.roller.machines?.map(m => m.machine_brand?.name)
                                    ).join(', ')}
                                </div>
                            </Space>
                        ),
                    }
                })}
            />
        </Form.Item>
    )
}

export default Rollers
